import React from 'react';
import Navigation from './Navigation';
import { HERO_TAGS } from '../../constants';

const HeroSection = ({ onExploreServices }) => {
  const heroTags = HERO_TAGS;

  return (
    <section 
      className="relative w-full h-screen min-h-[720px] sm:min-h-[650px] md:min-h-[700px] lg:h-screen lg:min-h-[900px] bg-cover bg-center bg-no-repeat overflow-hidden rounded-b-[20px] sm:rounded-b-[30px]" 
      style={{ 
        backgroundImage: "url('/hero-bg.jpg')" 
      }}
      id="home"
    >
      {/* Gradient Overlay - matching Figma: opacity 0.25 */}
      <div 
        className="absolute inset-0 opacity-25"
        style={{ 
          background: 'linear-gradient(270deg, rgba(102, 102, 102, 0.2) 0%, #000000 42.66%)' 
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 h-full flex flex-col pb-4">
        <Navigation />
        
        {/* Hero Content - positioned according to Figma */}
        <div className="px-4 sm:px-6 md:px-12 lg:px-24 flex flex-col justify-center flex-1 lg:flex-none lg:absolute lg:left-24 lg:top-[223px] lg:pt-0">
          <div className="max-w-full sm:max-w-[550px] lg:max-w-[650px]">
            {/* Powering Your Growth - top: 223px */}
            <h1 
              className="font-medium text-[26px] sm:text-[38px] md:text-[52px] lg:text-[62px] leading-[1.2] sm:leading-[1.25] lg:leading-[75px] text-white mb-3 sm:mb-4 md:mb-6"
            >
              Powering Your Growth<br />with Modern IT Solutions
            </h1>
            
            {/* Description - top: 378px (155px below title) */}
            <p 
              className="font-normal text-[13px] sm:text-[18px] md:text-[22px] lg:text-[26px] leading-[1.35] sm:leading-[1.5] lg:leading-[38px] text-white mb-5 sm:mb-6 md:mb-8 lg:mb-10 max-w-full sm:max-w-[500px] lg:max-w-[580px]"
            >
              Secure, stable operations powered by smart automation and 24/7 oversight.
            </p>
            
            {/* Button - Frame 14: top: 486px */}
            <button
              onClick={onExploreServices}
              className="px-8 py-4 rounded-[15px] font-medium text-[16px] md:text-[18px] text-white whitespace-nowrap transition-all duration-300"
              style={{
                background: 'linear-gradient(90deg, #F05736 0%, #FBB12F 100%)',
                fontFamily: 'Murecho, sans-serif'
              }}
            >
              Explore Services
            </button>
          </div>
        </div>

        {/* Hero Tags - Bottom: positioned at bottom */}
        <div className="absolute bottom-4 sm:bottom-6 lg:bottom-8 right-4 sm:right-6 lg:right-[8%] flex flex-row items-center justify-end gap-3 sm:gap-4 md:gap-6 lg:gap-12">
          {heroTags.map((tag) => (
            <span 
              key={tag}
              className="flex items-center gap-1.5 sm:gap-2 md:gap-4 font-medium text-[9px] sm:text-[12px] md:text-[16px] lg:text-[20px] leading-[1.3] sm:leading-[1.4] lg:leading-[29px] text-white whitespace-nowrap"
            >
              <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-[10px] md:h-[10px] bg-white rounded-full flex-shrink-0" />
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
